import { createSelector } from '@ngrx/store';
import { getCurrentHomeId } from '@library/store/homes/homes.selector';
import { AppState } from '../app.state';
import { HomeVelux } from './homes.interface';
import { Module } from '@library/store/modules/modules.interface';

const homesState = (state: AppState): HomeVelux[] => state.homes.homes;
const modulesState = (state: AppState): Module[] => state.modules.all;

export const getNotificationSettings = createSelector(
  getCurrentHomeId,
  homesState,
  (currentId, homes) => {
    const home = homes.find(h => h.id === currentId) as HomeVelux;
    if (!home) {
      return null;
    }
    return home.notification_settings;
  },
);

export const getCurrentHomeGateway = createSelector(
  getCurrentHomeId,
  modulesState,
  (currentId, modules) => {
    const gateway = modules.find(m => m.homeId === currentId && m.type === 'NXG');
    return gateway;
  },
);

export const getHomeMeasures = createSelector(
  getCurrentHomeId,
  homesState,
  (currentId, homes) => {
    return homes.find(home => home.id === currentId).measures;
  },
);
